<template>
    <div>
        <div>
            <fieldset>
                <div class="row">
                    <legend>Frame Information</legend>
                    
                    <div class="column small-12 medium-12">
                        <div class="row">
                            <div class="columns small-4 medium-2">Order Type:</div>
                            <div class="columns small-8 medium-10">New Frame</div>
                        </div>
                        <div class="row">
                            <div class="columns small-4 medium-2">Frame:</div>
                            <div class="columns small-8 medium-10">{{frame.model}} {{frame.color}} {{frame.aBox}}-{{frame.dbl}}-{{frame.templeLength}}</div>
                        </div>
          
                     </div>
                 
                </div>
            </fieldset>
        </div>

    </div>
</template>
<script>
export default {
  props: ["frame", "sampleobject"],
  created() {}
};
</script>
<style>
.frame-review-section {
  margin-top: 15px;
}

.uncut-smalltext {
  font-size: 11pt;
}
</style>
